import React, { useState, useEffect, useCallback, Fragment } from 'react';
import { Page, Layout, useBreakpoints, Toast, Divider } from '@shopify/polaris';
import { useDispatch, useSelector } from 'react-redux';
import { getPriceUpdateAsync } from '../redux/priceUpdate/index';
import { verifyAPIKeyAsync } from '../redux/userOnboarding';
import { getAllPriceUpdate } from '../redux/priceUpdate/slice';
import { getAllUserOnboarding } from '../redux/userOnboarding/slice';
import useOnboardingRedirect from '../redux/userOnBoardingRedirect';
import PriceUpdate from '../components/setting/PriceUpdate';
import LiveGoldRateAPI from '../components/setting/LiveGoldRateAPI';
import MetafieldMapping from '../components/setting/MetafieldMapping';
import GeneralAndAccount from '../components/setting/GeneralAndAccount';
import PricingFormula from '../components/setting/PricingFormula';
import TabComponent from '../components/common/Tab';
import Placeholder from '../components/common/Placeholder';
import LoadingComponent from '../components/common/Loading';
import { SETTING_TABS } from '../utils/json';
import '../styles/index.css';

const SettingPage = () => {
    const { smUp } = useBreakpoints();
    const dispatch = useDispatch();
    const { priceUpdateData, isLoading } = useSelector(getAllPriceUpdate);
    const { userOnboardingData, isAPIKeyVerifiedLoading, isAPIKeyVerified, apiKey } = useSelector(getAllUserOnboarding);
    const [isCall, setIsCall] = useState(false);
    const [serviceApiKey, setServiceApiKey] = useState('');
    const [active, setActive] = useState(false);
    const [message, setMessage] = useState('');
    const [isSuccess, setIsSuccess] = useState(false);
    const [tabIndex, setTabIndex] = useState(0);

    useOnboardingRedirect(userOnboardingData);

    const isNewAPIKey = process.env.GOLD_SERVICE_API_KEY === apiKey;

    const toggleActive = useCallback((success, message) => {
        setMessage(message);
        setActive((active) => !active);
        setIsSuccess(success);
    }, []);

    const toastMarkup = active ? (
        <Toast duration={2000} content={message} error={!isSuccess} onDismiss={toggleActive} />
    ) : null;

    useEffect(() => {
        dispatch(getPriceUpdateAsync());
    }, [dispatch, isCall]);

    useEffect(() => {
        if (apiKey) {
            setServiceApiKey(apiKey);
        }
    }, [apiKey]);

    const handleCallBack = () => {
        setIsCall(!isCall);
    };

    const handleConfigureAPIKey = () => {
        dispatch(verifyAPIKeyAsync({
            payload: { apiKey: serviceApiKey },
            callback: (success, message) => {
                if (success) {
                    toggleActive(success, message);
                    handleCallBack();
                } else {
                    toggleActive(success, message);
                }
            }
        }));
    };

    return (
        <Page>
            <TabComponent tabs={SETTING_TABS} selected={tabIndex} setSelected={setTabIndex}>
                {smUp ? <Divider /> : null}
                <Layout sectioned>
                    {tabIndex === 1 &&
                        <Fragment>
                            <LiveGoldRateAPI
                                isAPIKeyVerified={isAPIKeyVerified}
                                isNewAPIKey={isNewAPIKey}
                                isAPIKeyVerifiedLoading={isAPIKeyVerifiedLoading}
                                serviceApiKey={serviceApiKey}
                                setServiceApiKey={setServiceApiKey}
                                handleConfigureAPIKey={handleConfigureAPIKey}
                                apiKey={apiKey}
                            />
                            <Placeholder />
                            {smUp ? <Divider /> : null}
                            <PricingFormula />
                        </Fragment>
                    }
                    {tabIndex === 0 &&
                        <PriceUpdate
                            priceUpdateData={priceUpdateData}
                            handleCallBack={handleCallBack}
                        />
                    }
                    {tabIndex === 2 &&
                        <MetafieldMapping toggleActive={toggleActive} />
                    }
                    {tabIndex === 3 &&
                        <GeneralAndAccount />
                    }
                </Layout>
            </TabComponent>
            <Placeholder />
            {isLoading && <LoadingComponent />}
            {toastMarkup}
        </Page >
    );
}

export default SettingPage;